import { debounce } from 'lodash';
import { Dialog, Toast } from 'react-vant';
import { buildMiniProgramSchema, isQywx, isWxNew } from './qywx';
import ParseUrl from 'parse-url';
// 路由参数转换
export const splicingQueryParameters = (parameters: Record<string, any>) => {
  const str = Object.keys(parameters).reduce((pre, cur) => {
    return pre + cur + '=' + encodeURIComponent(parameters[cur]) + '&';
  }, '');

  return '?' + str.substring(0, str.length - 1);
};

// 是否是小程序
export const isMiniprogram = () => {
  return new Promise<void>((resolve, reject) => {
    if (!/MicroMessenger/i.test(navigator.userAgent)) {
      reject();
      return;
    }
    let windows: any = window;
    windows = windows.wx ? windows : parent.window;
    if (!windows.wx) reject();
    windows.wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        resolve();
      } else {
        reject();
      }
    });
  });
};

// 路由中获取数据
export const getCookieByName = (name) => {
  const cookieObj = {};
  if (document && document.cookie) {
    const cookiesArr = document.cookie.split(';');

    for (let i = 0; i < cookiesArr.length; i++) {
      const str = cookiesArr[i].trim();
      const [key, value] = str.split('=');
      cookieObj[key] = value;
    }
  }
  return cookieObj[name];
};

/**
 * 把对象参数 转换  字符串
 * @param {*} params
 */
export const handleParams = (params) => {
  let paramsStr = '?';
  if (params) {
    const arr = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      arr.push([key, params[key]]);
    }
    arr?.forEach((item, index) => {
      let single = item[0] + '=' + encodeURIComponent(JSON.stringify(item[1]));
      if (index !== arr?.length - 1) {
        single += '&';
      }
      if (single) {
        paramsStr += single;
      }
    });
  } else {
    paramsStr = '';
  }
  return paramsStr;
};

/**
 * 前往个人版登录前往个人版登录
 */
export const innerGotoLoginPage = (url) => {
  const query = {
    return_url: url,
    refer: 'personal',
  };
  return new Promise((resolve, reject) => {
    wx.miniProgram.navigateTo({
      url: `/pages/personalLogin/index${handleParams(query)}`,
      success: resolve,
      fail: reject,
    });
  });
};

/**
 * 前往个人版登录
 */
export const gotoPersonalLogin = debounce(() => {
  if (typeof window === 'undefined') {
    return;
  }
  isMiniprogram().then(
    () => {
      const url = window.location.href;
      innerGotoLoginPage(url);
    },
    () => {
      Toast.info('当前非小程序环境，无法使用个人登录');
    },
  );
}, 1000);

/**
 * 跳转微信小程序页面
 * @param {string} path 小程序页面路径
 * @param {object} params 参数对象
 */
export const gotoWXMiniprogramPage = (path, params) => {
  const str = handleParams(params);
  isMiniprogram().then(() => {
    const finalPath = path + str;
    wx?.miniProgram.navigateTo({ url: finalPath });
  });
};

// 优选优服小程序打开方法
const yxyfMiniProgramAppId = 'wxd853c6e0eb451605';
export function openYxyfMiniProgramSchema(path: string) {
  const params = {
    appid: yxyfMiniProgramAppId,
    name: '严选优服',
    path,
  };
  const url = `/pages/jumpMiniProgram/index${handleParams(params)}`;
  wx.miniProgram.navigateTo({
    url: url,
    success: () => {
      console.log('落地页跳转成功====');
    },
    fail: () => {
      Toast('小程序跳转失败，请稍后重试');
    },
  });
}

/**
 * 路由添加上token
 */
const addUnionToken = (url, token) => {
  if (!token) {
    return url;
  }
  const tempUrl = new URL(url);
  const params = tempUrl.searchParams;
  // 如果已经存在 token，则删除
  if (params.has(YXYF_TOKEN)) {
    params.delete(YXYF_TOKEN);
  }
  params.set(YXYF_TOKEN, token);

  return tempUrl.toString();
};

// 统一打开banner或者navbar上面的动态配置入口
// 新增打开优选优服小程序（通过url上面的yxyf=true判断）
export const YXYF_TOKEN = 'token';
export const appLinkRecirect = (url, router) => {
  if (!url) {
    console.log('current url is null');
    return;
  }
  let extraQuery = {} as { miniProgramPath?: string; yxyf?: boolean };
  try {
    extraQuery = ParseUrl(url).query;
  } catch (e) {
    console.error(e);
    extraQuery = {} as { miniProgramPath?: string; yxyf?: boolean };
  }
  const { miniProgramPath, yxyf } = extraQuery;
  if (yxyf) {
    console.log('open yxff page', miniProgramPath);
    const token = localStorage.getItem(YXYF_TOKEN);
    // 是否打开优选优服小程序
    if (isWxNew() && miniProgramPath) {
      // openYxyfMiniProgramSchema(miniProgramPath);
      Dialog.alert({
        title: '提示',
        closeable: true,
        theme: 'round-button',
        message: '目前快递和个人商城服务功能已移至“云采严选优服”小程序，烦请前往新小程序进行下单。',
      });
    } else {
      const newUrl = addUnionToken(url, token);
      router.push(newUrl);
    }
  } else {
    console.log('open yxsc page');
    if (isWxNew()) {
      if (miniProgramPath) {
        wx.miniProgram.navigateTo({ url: miniProgramPath });
      } else {
        router.push(url);
      }
    } else {
      const miniProgramPathList = ['/pages/personal/index'];
      const isMimiPrograms = miniProgramPathList.includes(miniProgramPath);
      if (isQywx && isMimiPrograms) {
        const schemaUrl = buildMiniProgramSchema(miniProgramPath);
        location.href = schemaUrl;
      } else {
        router.push(url);
      }
    }
  }
};
